import { ComponentProps, FC, ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "shared/components/Spor";

type TextTooltipProps = Omit<
  ComponentProps<typeof Tooltip>,
  "children" | "positioning"
> &
  Pick<ComponentProps<typeof TooltipContent>, "showArrow"> & {
    children: ReactNode;
    label?: ReactNode;
    placement?: NonNullable<
      ComponentProps<typeof Tooltip>["positioning"]
    >["placement"];
    isDisabled?: boolean;
  };

export const TextTooltip: FC<TextTooltipProps> = ({
  children,
  label,
  showArrow,
  placement,
  isDisabled,
  ...props
}) => {
  if (!label) {
    return children;
  }

  return (
    <Tooltip
      {...props}
      positioning={placement ? { placement } : undefined}
      disabled={isDisabled}
    >
      <TooltipTrigger>{children}</TooltipTrigger>
      <TooltipContent showArrow={showArrow}>{label}</TooltipContent>
    </Tooltip>
  );
};
